export const storyByFamily = {
    'familie-thumann': ['thumann', 'dumen', 'duman', 'doumann', 'thoumann'],
    'familie-jacobsz': ['jacobsz'],
    // meer familieverhalen...
}

// export const storyByPersonID = {
//     'in-de-schaduw-van-4-mei': ['I42', 'I43', 'I88', 'I90', 'I91'],
//     // eventueel ook andere verhalen...
// }